import React from "react";
import Plotly from "plotly.js-cartesian-dist-min";
import createPlotlyComponent from "@src/utils/plotlyWrapper";
import AppUtils from "@src/utils/appUtils";
import PropTypes from "prop-types";
import { Loader } from "../atoms";

const PlotlyGraph = (props) => {
  const Plot = createPlotlyComponent(Plotly);
  const { plotyJSON, width, padding = 0 } = props;
  const layoutOverrides = {
    // height: 800,
    width: width, // - padding * 4 * 2,
  };
  const updatedLayout = Object.assign({}, plotyJSON.layout, layoutOverrides);
  updatedLayout.template.layout.yaxis.automargin = true;
  updatedLayout.template.layout.xaxis.automargin = true;
  return (
    // <div className={`box-border w-full h-full p-${padding}`}>
    <div className={`box-border`}>
      {plotyJSON ? (
        <Plot
          data={plotyJSON.data}
          layout={updatedLayout}
          config={{ displayModeBar: false }}
        />
      ) : (
        <Loader />
      )}
    </div>
  );
};

export const PlotlyGraphControls = {};

PlotlyGraph.propTypes = AppUtils.getPropTypeFromControls(PlotlyGraphControls);

export default PlotlyGraph;
